import ApiRequest from "../index"

const subCategoriasRequest = {
    getSubCategorias: async id => ApiRequest.get(`/v2/lojinha/category/sub/list/${id}`),
    putSubCategoriasUpdate: async data => ApiRequest.put(`/v2/lojinha/category/sub/update`, {...data}),
    deleteSubCategoriasDelete: async id => ApiRequest.delete(`/v2/lojinha/category/sub/delete/${id}`),
    postSubCategoriasCreate: async data => ApiRequest.post(`/v2/lojinha/category/sub/create`, {...data}),
}

export default subCategoriasRequest